import * as angular from 'angular';
import {IController} from 'angular';
import {BringozLoaderService} from "../../../../commons/services/bringoz-loader.service";
import {ReportsRequests} from "../../../services/reports-requests.service";
import {CommonsAlertsService} from "../../../../commons/services/commons-alerts.service";
import {DateRangeTimeFiltersService} from "../../../../commons/services/date-range-time-filters.service";
import {ResizeService} from "../../../../commons/services/resize-service.service";
import {SiteFiltersType} from "../../../../commons/types/site-filters.type";
import * as _ from "lodash";
import {AgentType} from "../../../../agents/types/agent.type";
import {WeekDaysEnum} from "../../../../commons/angular/enums/week-days.enum";
import {TagType} from "../../../../tags/angular/types/tag.type";
import {ViewFilterSettingsService} from "../../../../commons/services/view-filter-settings.service";
import {ViewSettingsModel} from "../../../../commons/models/view-settings.model";

export class ReportsRoutesAccuracyDriversComponent implements IController {
  from: any;
  to: any;
  agentIds: string[];
  branchIds: string[];
  agentType: AgentType;
  tags: any;
  accountIds: string[];
  selectedQuickFilterId: string;

  public pageName: string;
  public chartData: any;
  public tableData: any;
  public widgetPieChartTotalsSegments: any;
  public limit: any;
  public offset: any;
  public filterConfig: any;
  public expandRowsMap: any = {};
  public weekDayOptions: string[];
  public isBigScreen: boolean;

  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private reportsRequests: ReportsRequests, private $state,
              private viewFilterSettingsService: ViewFilterSettingsService, private $mdMedia) {
  }

  $onInit() {
    this.pageName = this.$state.current.name;
    this.weekDayOptions = Object.keys(WeekDaysEnum);
    this.filterConfig = {
      bringozFilters: {
        [SiteFiltersType.branchIds]: this.branchIds || [],
        [SiteFiltersType.agentIds]: this.agentIds || [],
        [SiteFiltersType.tags]: this.tags || [],
        [SiteFiltersType.accountIds]: this.accountIds || [],
        [SiteFiltersType.agentType]: this.agentType,
      },
      includeFilters: [SiteFiltersType.branchIds, SiteFiltersType.agentIds, SiteFiltersType.agentType, SiteFiltersType.accountIds, SiteFiltersType.tags],
      queryMap: {
        tagType: TagType.Agent
      },
      range: this.from && this.to ? {
        dateStart: this.from,
        dateEnd: this.to
      } : this.dateRangeTimeFiltersService.lastMonth(),
      customTemplates: this.dateRangeTimeFiltersService.getReportCustomTemplates()
    };

    this.isBigScreen = this.$mdMedia('(min-width: 1200px)');

    this._generateReports();
    this._getAgentSummaryParams();
  }

  onWeekDaysChange(selectedDays) {
    this.filterConfig.bringozFilters.weekDays = selectedDays;
    this._generateReports();
    this._getAgentSummaryParams();
  }

  onRangeChanged(range) {

    // if (this.selectedQuickFilterId && range?.dateStart !== this.filterConfig.dateStart && range?.dateEnd !== this.filterConfig.dateEnd) {
    //   this.selectedQuickFilterId = undefined;
    // }

    this.filterConfig.range = range;
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
    this._generateReports();
    this._getAgentSummaryParams();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filterConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.filterConfig.bringozFilters = filters;
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
    this._generateReports();
    this._getAgentSummaryParams();
  }

  // onExport(event) {
  //   const payload = this._getQueryPayload();
  //   this.bringozLoaderService.on();
  //   this.reportsRequests.exportDeliveriesCompletion(payload.from, payload.to, 'vendor', this.groupBy,
  //     undefined, undefined, payload.supplyId)
  //     .then((file) => {
  //       this.commonsAlertsService.exportToMailSuccess();
  //     })
  //     .catch((error) => {
  //       this.commonsAlertsService.exportToMailError();
  //       this.$log.error('Failed to export file', error);
  //     })
  //     .finally(() => {
  //       this.bringozLoaderService.off();
  //     })
  // }

  // onToggleExpend(sectionExpended) {
  //   this.expend[sectionExpended] = !this.expend[sectionExpended];
  //   this.flex[sectionExpended] = this.expend[sectionExpended] ? undefined : 'none';
  //   this.resizeService.resize();
  // }

  onBack() {
    this.offset -= this.limit;
    this._setMainReport();
  }

  onNext() {
    this.offset += this.limit;
    this._setMainReport();
  }

  onToggleTableExpand(agentId) {
    if (!!this.expandRowsMap[agentId]) {
      this.expandRowsMap[agentId] = undefined;
    } else {
      const params = {
        from: this.filterConfig.range.dateStart,
        to: this.filterConfig.range.dateEnd,
        weekDays: this.filterConfig.bringozFilters.weekDays,
        agentId: agentId
      }
      this.reportsRequests.getAgentRoutesPerformance(params)
        .then((res: any) => {
          this.expandRowsMap = {
            ...this.expandRowsMap,
            [agentId]: res.list
          }
        })
    }
  }

  private _generateReports() {
    this.limit = 20;
    this.offset = 0;
    this._setMainReport();
  }

  private _getAgentSummaryParams() {
    const agentSummaryParams = this._getQueryPayload();

    this.reportsRequests.getAgentRoutesPerformanceSummary(agentSummaryParams)
      .then((res) => {
        this.chartData = res;
        this.initPieChartTotalsWidgetData(res);
      })
  }

  private _setMainReport() {

    const agentPerformanceDetails = {
      ...this._getQueryPayload(),
      offset: this.offset,
      limit: this.limit
    }

    this.reportsRequests.getAgentsPerformanceDetails(agentPerformanceDetails)
      .then((res: any) => {
        this.tableData = res.list;
        this.expandRowsMap = {};
      })
  }


  private _getQueryPayload() {
    return {
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      accountIds: this.filterConfig.bringozFilters.accountIds,
      weekDays: this.filterConfig.bringozFilters.weekDays,
      tags: this.filterConfig.bringozFilters.tags,
      agentIds: this.filterConfig.bringozFilters.agentIds,
      agentTypes: this.filterConfig.bringozFilters.agentTypes
    }
  }

  private initPieChartTotalsWidgetData(data) {
    this.widgetPieChartTotalsSegments = {
      innerTextConfiguration: undefined,
      segments: []
    };

    const pieChartKeys = Object.keys(data);
    const averageScore = Math.round((_.reduce(pieChartKeys, (scoreSum, key: string) => {
      return scoreSum + data[key];
    }, 0) || 0) / pieChartKeys.length);

    const averageScoreSegment = {
      value: averageScore,
      color: this.routeScoreColor(averageScore)
    }
    this.widgetPieChartTotalsSegments.innerTextConfiguration = {
      color: this.routeScoreColor(averageScore),
      text: averageScore + '%'
    }
    this.widgetPieChartTotalsSegments.segments.push(averageScoreSegment);

    const averageScoreSegmentDiff = {
      value: 100 - averageScore,
      color: this.addAlphaToRgb(this.routeScoreColor(averageScore), 0.3)
    }

    this.widgetPieChartTotalsSegments.segments.push(averageScoreSegmentDiff);

  }

  private routeScoreColor(routeScore) {
    let color;
    switch (true) {
      case routeScore <= 60: {
        color = 'rgb(213, 36, 36)';
        break;
      }
      case routeScore > 60 && routeScore < 80: {
        color = 'rgb(221, 114, 32)';
        break;
      }
      case routeScore >= 80: {
        color = 'rgb(47, 133, 47)';
        break;
      }
      default: {
        color = 'rgb(47, 133, 47)';
        break;
      }
    }

    return color;
  }

  private addAlphaToRgb(rgb, alpha) {
    const [r, g, b] = rgb.match(/\d+/g).map(Number);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  private _getQueryParams() {
    return {
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      accountIds: this.filterConfig.bringozFilters.accountIds,
      tags: this.filterConfig.bringozFilters.tags,
      selectedQuickFilterId: this.selectedQuickFilterId,
      agentIds: this.filterConfig.bringozFilters.agentIds,
      agentType: this.filterConfig.bringozFilters.agentType
    }
  }

}

angular
  .module('bringoz.admin.reports')
  .component('reportsRoutesAccuracyDrivers', {
    bindings: {
      from: '<',
      to: '<',
      agentIds: '<?',
      branchIds: '<?',
      agentType: '<?',
      tags: '<?',
      accountIds: '<?',
      selectedQuickFilterId: '<?'
    },
    template: require('./reports-routes-accuracy-drivers.html').default,
    controller: ReportsRoutesAccuracyDriversComponent
  });
